var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var models;
    (function (models) {
        var ValueOperation = /** @class */ (function (_super) {
            __extends(ValueOperation, _super);
            function ValueOperation() {
                return _super.call(this) || this;
            }
            ValueOperation.prototype.getVariableTypeSymbol = function () {
                switch (this.variableType) {
                    case 0 /* String */:
                        return "S";
                    case 1 /* Integer */:
                        return "I";
                    case 2 /* Decimal */:
                        return "Dc";
                    case 3 /* DateTime */:
                        return "Dt";
                    case 4 /* Date */:
                        return "D";
                    case 5 /* Time */:
                        return "T";
                    case 6 /* Boolean */:
                        return "B";
                    case 24 /* Code */:
                        return "C";
                    default:
                        return "?";
                }
            };
            ValueOperation.prototype.getVariableTypeName = function () {
                switch (this.variableType) {
                    case 0 /* String */:
                        return "String";
                    case 1 /* Integer */:
                        return "Integer";
                    case 2 /* Decimal */:
                        return "Decimal";
                    case 3 /* DateTime */:
                        return "Date/Time";
                    case 4 /* Date */:
                        return "Date";
                    case 5 /* Time */:
                        return "Time";
                    case 6 /* Boolean */:
                        return "Boolean";
                    case 24 /* Code */:
                        return "Code";
                    default:
                        return "Unknown";
                }
            };
            return ValueOperation;
        }(BaseEntity));
        models.ValueOperation = ValueOperation;
    })(models = warsApp.models || (warsApp.models = {}));
})(warsApp || (warsApp = {}));
